module.exports = __webpack_public_path__ + "static/media/insu-henner.37c30cab.svg";